<script>
import ETicketForm from './form';

export default {
   name: 'EditETicketFormModal',
   components: { ETicketForm },
   data() {
      return {
         data: {}, 
      }
   },
   methods: {
      populateAndShowModal(parentData) {
         delete parentData.coupon_type
         this.data = parentData
         this.$bvModal.show('editETicketFormModal')
      },
      closeModal() {
         this.$bvModal.hide('editETicketFormModal')
         this.$emit('closeModal');
      }
   }
}
</script>

<template>
   <b-modal id="editETicketFormModal" class="modal-xxl" centered hide-footer size="xl">
      <template #modal-header>
         <div ref="top">
            <h3>{{ $t('account-page-facility-my-page-e-ticket.index.edit_modal_title') }}</h3>
         </div>
         <button type="button" class="close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
         </button>
      </template>
      <ETicketForm :isEditMode="true" :toEditData="data" @close="closeModal" @scroll="$refs.top.scrollIntoView()" />
   </b-modal>
</template>